module.exports = __webpack_public_path__ + "media/images/sort_asc_disabled-bda51e15.png";